// reducers/userReducer.js
import { SET_USER } from 'actions';

const initialState = {
  user: null, // 初始状态下没有用户信息
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        user: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;